import { flow } from 'fp-ts/function';
import { concat, identity, join, map } from 'lodash/fp';

const FIRST_FOCUSABLE_ELEMENT_SELECTOR = [
    'button',
    '[href]',
    'input:not([type="hidden"])',
    'select',
    'textarea',
    '[tabindex]:not([tabindex="-1"])',
];

export const getFirstFocusableElementSelectors = (transformer = identity, additionalElements = []) =>
    flow(concat(FIRST_FOCUSABLE_ELEMENT_SELECTOR), map(transformer), join(','))(additionalElements);
